@if (isVisible()) {
  <div class="upload-progress-container">
    <!-- Offline banner -->
    @if (!isOnline()) {
      <div class="offline-banner">
        <app-svg name="info" [color]="ss.theme().color7"></app-svg>
        <span class="text-14-500 color-7">{{ ss.t('dataUploadingProcess_offlineInfo') }}</span>
      </div>
    }

    <!-- Upload queue header -->
    <div class="queue-header">
      <span class="text-14-600 color-8">
        {{ ss.t('common_upload') }} ({{ activeEntries().length }})
      </span>
      @if (failedEntries().length > 0) {
        <button class="retry-all-btn text-12-500 color-35" (click)="retryAll()">
          {{ ss.t('refreshData_retry') }}
        </button>
      }
    </div>

    <!-- Upload entries -->
    <div class="queue-entries">
      @for (entry of activeEntries(); track entry.id) {
        <div class="queue-entry" [class.failed]="entry.status === 'failed'" [class.uploading]="entry.status === 'uploading'">
          <!-- File type icon -->
          <div class="entry-icon">
            <app-svg [name]="getFileTypeIcon(entry)" [color]="ss.theme().color8"></app-svg>
          </div>

          <!-- File info and progress -->
          <div class="entry-content">
            <div class="entry-header">
              <span class="entry-filename text-14-500 color-8">{{ truncateFilename(entry.originalFileName) }}</span>
              <span class="entry-size text-12-400 color-7">{{ formatFileSize(entry.sizeInBytes) }}</span>
            </div>

            <!-- Progress bar -->
            @if (entry.status === 'uploading' || entry.status === 'processing') {
              <div class="progress-bar-container">
                <div class="progress-bar" [style.width.%]="entry.uploadProgress"></div>
              </div>
            }

            <!-- Status text -->
            <div class="entry-status">
              <span class="text-12-400" [class.color-7]="entry.status !== 'failed'" [class.color-error]="entry.status === 'failed'">
                {{ getStatusText(entry) }}
              </span>

              <!-- Retry count indicator -->
              @if (entry.status === 'failed' && entry.retryCount > 0) {
                <span class="retry-count text-12-400 color-7">
                  ({{ entry.retryCount }}/{{ entry.maxRetries }})
                </span>
              }
            </div>
          </div>

          <!-- Action buttons -->
          <div class="entry-actions">
            @if (entry.status === 'failed' && entry.retryCount < entry.maxRetries) {
              <button class="action-btn retry-btn" (click)="retryUpload(entry)" [title]="ss.t('forceUpdate_retry')">
                <app-svg name="sync" [color]="ss.theme().color35"></app-svg>
              </button>
            }
            @if (entry.status === 'pending' || entry.status === 'failed') {
              <button class="action-btn cancel-btn" (click)="cancelUpload(entry)" [title]="ss.t('common_cancel')">
                <app-svg name="close" [color]="ss.theme().color7"></app-svg>
              </button>
            }
          </div>
        </div>
      }
    </div>
  </div>
}
